//Annotated stations should be temporarily hidden.
export default {
    hydrologicalStations: [
        { name: 'Puente Samaná - ISAGEN', id: 283},
        { name: 'Q. Cristales - Valles de La Alhambra', id: 170 },
        { name: 'Q. El Bohío', id: 156 },
        { name: 'Q. El Guamo - CDI San Sebastián', id: 155 },
        { name: 'Q. El Guamo - Lavadero Los Puentes', id: 164 },
        { name: 'Q. El Perro - Expoferias', id: 165 },
        { name: 'Q. El Rosario - Autopistas', id: 210 },
        { name: 'Q. El Rosario - San Marcos de León', id: 154 },
        { name: 'Q. Guayabal - Recinto del Pensamiento', id: 209},
        //{ name: 'Q. La Estrella', id: 65 },
        { name: 'Q. La Francia - Los Puentes', id: 153 },
        { name: 'Q. Las Pavas - Autopistas del Café', id: 152 },
        { name: 'Q. Manizales - Maltería', id: 180 },
        { name: 'Q. Manzanares - IBC', id: 151 },
        { name: 'Q. Marmato - Planta Chec', id: 158 },
        { name: 'Q. Molinos P.N.N.N.', id: 34 },
        //{ name: 'Q. Nereidas - Chec', id: 208},
        { name: 'Q. Nereidas P.N.N.N.', id: 35 },
        { name: 'Q. Olivares - Aguas de Manizales', id: 167 },
        { name: 'Q. Olivares - Bocatoma', id: 175 },
        { name: 'Q. Olivares - Bomberos Voluntarios', id: 163 },
        { name: 'Q. Olivares - El Popal', id: 7 },
        { name: 'Q. Palogrande - Ruta 30', id: 30 },
        { name: 'Q. Palogrande - Terminal de Transportes', id: 160 },
        { name: 'Q. Salinas - Relleno Sanitario Emas', id: 162 },
        { name: 'Q. Tesorito', id: 6 },
        { name: 'Q. El Triunfo - Mirador de Villapilar', id: 166 },
        //{ name: 'Río Campoalegre - Ínsula', id: 66 },
        //{ name: 'Río Campoalegre - Tarapacá', id: 67 },
        //{ name: 'Río Chinchiná - Bocatoma Municipal', id: 69 },
        //{ name: 'Río Chinchiná - Bocatoma Montevideo', id: 68 },
        { name: 'Río Chinchiná - Bosque Popular', id: 161 },
        { name: 'Río Chinchiná - Cenicafé', id: 72 },
        { name: 'Río Chinchiná - El Bosque', id: 193 },
        { name: 'Río Chinchiná - La Virginia', id: 288},
        { name: 'Río Chinchiná - La Zulia', id: 287},
        //{ name: 'Río Chinchiná - Jardines', id: 204},
        //{ name: 'Río Chinchiná - Bocatoma Sancancio', id: 70 },
        { name: 'Río Doña Juana', id: 61 },
        //{ name: 'Río Guacaica - Bocatoma', id: 71 },
        { name: 'Río Guacaica - Chec', id: 8 },
        { name: 'Río Guacaica - El Jordan', id: 9 },
        { name: 'Río Pácora', id: 62 },
        { name: 'Río Pensilvania - Microcentral', id: 10 },
        { name: 'Río Pozo', id: 11 },
        { name: 'Río Rioclaro - La Batea', id: 74 },
        { name: 'Río Rioclaro - La Guayana', id: 12 },
        { name: 'Río Rioclaro P.N.N.N.', id: 36},
        { name: 'Río Risaralda - La Palmera', id: 2 },
        //{ name: 'Río San Francisco', id: 64 },
        { name: 'Río Santo Domingo - Manzanares', id: 13 },
        { name: 'Río Supía - Los Piononos', id: 14 },
        { name: 'Río Supía - Supía', id: 15 },
        { name: 'Río Tapias', id: 63},
        { name: 'Tarro Pintado - ISAGEN', id: 282}
    ]
}